<template>
    <div>
        <h-table
            :data="data"
            row-key="label"
            :columns="columns"
            :visible-columns="visibleColumns"
            :loading="loading"
            :hide-bottom="true"
            ref="table"
            @request="fetchData"
        >
            <q-td
                slot="body-cell-edit"
                class="text-right"
                slot-scope="props"
            >
                <q-btn
                    @click="updateProjectConfig(props.value)"
                    icon="edit"
                    color="tertiary"
                    class="hover-primary"
                    flat
                    round
                />
            </q-td>
        </h-table>
        <update-mcp-project-config
            v-model="isProjectConfigUpdateOpen"
            :project-config="projectConfig"
            @save="updateProjectConfigs()"
        />
    </div>
</template>

<script>
import {HTable, HTh} from '@'

import tableHelpers from '@/HTable/helpers'
import api from 'mixins/api'
import columns from './mixins/columns'

import {
  QBtn,
  QBtnToggle,
  QField,
  QIcon,
  QInput,
  QPopover,
  QTable,
  QTableColumns,
  QTd,
  QTh,
  QTooltip,
  QTr,
} from 'quasar'
import UpdateMcpProjectConfig from "./UpdateMcpProjectConfig.vue";

export default {
  name: 'McpProjectConfigs',
  components: {
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QField,
    QInput,
    QBtn,
    QBtnToggle,
    QIcon,
    QTooltip,
    QPopover,
    HTable,
    HTh,
    UpdateMcpProjectConfig,
  },
  mixins: [
    tableHelpers,
    api,
    columns,
  ],
  data () {
    return {
      visibleColumns: this.getVisibleColumns() || ['region', 'database_id', 'backend_name', 'created_at', 'updated_at', 'edit'],
      isProjectConfigUpdateOpen: false,
      projectConfig: {
        database_id: '',
        backend_name: '',
      },
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      this.api.get(`project_configs`).then(response => {
        this.updateData(response.data)
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    },
    updateProjectConfigs () {
      this.fetchData()
    },
    updateProjectConfig (id) {
      this.isProjectConfigUpdateOpen = true
      Object.assign(this.projectConfig, this.data.find(row => row.id === id))
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/McpProjectConfigs/McpProjectConfigs.vue